module.exports = __webpack_public_path__ + "img/offer-correct.b8ae705c.svg";